import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import clsx from 'clsx';
import isNumber from 'lodash/isNumber';
import Link from '#web-components/components/Link';
import Typography from '#web-components/components/Typography';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import menuPanelStyles from './MenuPanel.styles';

export interface Props {
  title: string;
  linkComponent: React.ElementType;
  titleLink: string;
  countDescription?: string;
  count?: number;
  hasError?: boolean,
  unknownErrorText?: string,
  disabled?: boolean,
  'data-xpath'?: string;
}

const useStyles = makeStyles(menuPanelStyles, { name: 'MenuPanel' });

export default function MenuPanel({
  count,
  title,
  titleLink,
  countDescription,
  hasError,
  linkComponent,
  unknownErrorText,
  disabled,
  'data-xpath': dataXpath,
}: Props) {
  const classes = useStyles();

  return (
    <Link
      to={titleLink}
      className={clsx(classes.root, {
        [classes.disabled]: disabled,
        [classes.enabled]: !disabled,
        [classes.alignCenter]: !isNumber(count) || !hasError,
      })}
      component={linkComponent}
      data-xpath={dataXpath}
    >
      <OpenInNewIcon className={classes.icon} />
      <Box className={classes.count}>
        {hasError ? <Typography halfOpacity variant="h3" component="h3">{unknownErrorText}</Typography> : (
          isNumber(count) && (
          <Typography variant="h1" component="h3">
            { count }
          </Typography>
          )
        )}
      </Box>
      <Typography variant="h4" component="h2" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="textSmallCompact" className={classes.description}>
        { countDescription }
      </Typography>
    </Link>
  );
}
